import React from "react";

export const ListTableScrollBoundaryRefContext =
  React.createContext<React.RefObject<HTMLElement | null> | null>(null);

export function useListTableScrollBoundaryRef(): React.RefObject<HTMLElement | null> | null {
  return React.useContext(ListTableScrollBoundaryRefContext);
}
